import { webToCatchFaceConnect2 } from 'src/features/brands/treasure/canvas/glove/back/lace/webToCatchFaceConnect'
import { webTops } from 'src/features/brands/treasure/canvas/glove/back/lace/webTop'
import { connectWebToIndexTop, connectWebToThumbTop } from 'src/features/brands/treasure/canvas/glove/back/lace/connectWebAndFinger'
import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'

export const wt10Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  jointOfThumbFinger2(ctx, webColor, laceColor, 55, -57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 25, -25)
  ctx.fillStyle = webColor

  // ウェブパーツ
  ctx.beginPath()
  ctx.moveTo(576, 44) // 左上
  ctx.quadraticCurveTo(521, 127, 498, 211) // 左下
  ctx.quadraticCurveTo(561, 255, 605, 342) //右下
  ctx.quadraticCurveTo(630, 347, 635, 337) //
  ctx.quadraticCurveTo(672, 308, 721, 245) //右上
  ctx.quadraticCurveTo(625, 70, 576, 44) //左上
  ctx.fill()
  ctx.quadraticCurveTo(529, 127, 500, 212) // 左下の革紐の穴上部
  ctx.moveTo(564, 69) // 左上
  ctx.quadraticCurveTo(640, 148, 704, 262) // 左下
  // 中央縦＿左
  ctx.moveTo(608, 141) // 上
  ctx.quadraticCurveTo(576, 211, 576, 211) // 下
  // 中央縦＿右
  ctx.moveTo(655, 205) // 上
  ctx.quadraticCurveTo(615, 255, 615, 255) // 下
  ctx.stroke()
  ctx.closePath()
  jointOfIndexFinger(ctx, webColor, laceColor, 9, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -18, 90)

  designOfWT10WebLeft(ctx, 5, 5)
  designOfWT10WebLeft(ctx, -14, 40)
  designOfWT10WebLeft(ctx, -33, 82)
  designOfWT10WebRight(ctx, -8, 2)
  designOfWT10WebRight(ctx, -25, 28)
  designOfWT10WebRight(ctx, -49, 49)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 横向き＿上
  ctx.moveTo(572, 60) // 左上
  ctx.quadraticCurveTo(659, 147, 708, 251) // 右下
  ctx.moveTo(570, 64) // 左上
  ctx.quadraticCurveTo(657, 151, 706, 255) // 右下
  // 外側
  ctx.moveTo(566, 75) // 左上
  ctx.quadraticCurveTo(529, 139, 505, 210) // 左下
  ctx.quadraticCurveTo(570, 265, 605, 335) // 右下
  ctx.quadraticCurveTo(634, 346, 700, 260) // 右上
  // 縦＿中央＿内
  ctx.moveTo(616, 137) // 左上
  ctx.quadraticCurveTo(582, 212, 582, 212) // 左下
  ctx.quadraticCurveTo(612, 247, 612, 247) // 右下
  ctx.quadraticCurveTo(635, 223, 655, 191) // 右上
  ctx.quadraticCurveTo(616, 135, 616, 137) // 右上
  // 内側
  ctx.moveTo(569, 77) // 左上
  ctx.quadraticCurveTo(562, 91, 562, 91) // 下
  ctx.quadraticCurveTo(592, 128, 592, 130) // 右上
  ctx.quadraticCurveTo(592, 140, 576, 140) // 右下
  ctx.quadraticCurveTo(552, 109, 552, 109) // 左下
  ctx.quadraticCurveTo(543, 128, 543, 128) // 左上
  ctx.quadraticCurveTo(573, 162, 573, 162) // 右上
  ctx.quadraticCurveTo(575, 175, 556, 175) // 右下
  ctx.quadraticCurveTo(535, 147, 535, 147) // 左下
  ctx.quadraticCurveTo(524, 172, 524, 172) // 左上
  ctx.quadraticCurveTo(553, 204, 553, 204) // 右上
  ctx.quadraticCurveTo(555, 220, 537, 215) // 右下
  ctx.quadraticCurveTo(517, 190, 517, 190) // 左下
  // 底辺
  ctx.quadraticCurveTo(511, 206, 511, 206) // 左下
  ctx.quadraticCurveTo(573, 264, 609, 333) // 右下
  // 右下＿デザイン3
  ctx.quadraticCurveTo(628, 331, 642, 318) // 右下
  ctx.quadraticCurveTo(611, 297, 611, 297) // 左下
  ctx.quadraticCurveTo(606, 280, 618, 279) // 左上
  ctx.quadraticCurveTo(654, 304, 654, 304) // 右上
  // デザイン２
  ctx.quadraticCurveTo(662, 295, 662, 295) // 右下
  ctx.quadraticCurveTo(636, 277, 636, 277) // 左下
  ctx.quadraticCurveTo(634, 255, 644, 258) // 左上
  ctx.quadraticCurveTo(674, 282, 674, 282) // 右上
  // デザイン1
  ctx.quadraticCurveTo(682, 272, 682, 272) // 右下
  ctx.quadraticCurveTo(665, 257, 654, 250) // 左下
  ctx.quadraticCurveTo(651, 230, 662, 235) // 左上
  ctx.quadraticCurveTo(691, 260, 691, 260) // 右上
  ctx.quadraticCurveTo(697, 256, 697, 256) // 右上
  // 中央
  ctx.quadraticCurveTo(663, 204, 663, 204) // 右上
  ctx.quadraticCurveTo(615, 265, 615, 265) // 右下
  ctx.quadraticCurveTo(569, 210, 569, 210) // 左下
  ctx.quadraticCurveTo(607, 123, 607, 123) // 左上
  // ウェブ左上
  ctx.quadraticCurveTo(569, 79, 569, 79) // 左上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // stitchここまで

  // laceここから
  ctx.fillStyle = laceColor
  // 左＿縦
  ctx.beginPath()
  ctx.moveTo(605, 159) // 左上
  ctx.quadraticCurveTo(594, 181, 594, 181) //左下
  ctx.quadraticCurveTo(601, 189, 601, 189) //右下
  ctx.quadraticCurveTo(612, 166, 612, 166) //右上
  ctx.quadraticCurveTo(605, 159, 605, 159) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 右＿縦
  ctx.beginPath()
  ctx.moveTo(637, 198) // 左上
  ctx.quadraticCurveTo(625, 216, 625, 216) //左下
  ctx.quadraticCurveTo(631, 224, 631, 224) //右下
  ctx.quadraticCurveTo(643, 206, 643, 206) //右上
  ctx.quadraticCurveTo(637, 198, 637, 198) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 縦＿下
  // 左＿縦
  ctx.beginPath()
  ctx.moveTo(590, 195) // 左上
  ctx.quadraticCurveTo(585, 204, 585, 204) //左下
  ctx.quadraticCurveTo(588, 210, 592, 209) //右下
  ctx.quadraticCurveTo(597, 201, 595, 201) //右上
  ctx.quadraticCurveTo(590, 193, 590, 195) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 右＿縦
  ctx.beginPath()
  ctx.moveTo(618, 227) // 左上
  ctx.quadraticCurveTo(612, 234, 612, 234) //左下
  ctx.quadraticCurveTo(618, 240, 618, 240) //右下
  ctx.quadraticCurveTo(625, 232, 625, 232) //右上
  ctx.quadraticCurveTo(618, 227, 618, 227) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // webToCatchFaceConnect(ctx, laceColor, -35, 17)
  webToCatchFaceConnect2(ctx, laceColor, -25, 27)
  webToCatchFaceConnect2(ctx, laceColor, 25, 80)
  webTops(ctx, laceColor, 20, 82) // 右＿親指から1番目
  webTops(ctx, laceColor, 15, 70) // 右＿親指から2番目
  webTops(ctx, laceColor, 5, 51) // 右＿親指から3番目
  webTops(ctx, laceColor, -7, 30) // 右＿親指から4番目
  webTops(ctx, laceColor, -20, 10) // 右＿親指から5番目
  webTops(ctx, laceColor, -33, -10) // 右＿親指から6番目
  webTops(ctx, laceColor, -45, -29) // 右＿親指から7番目
  webTops(ctx, laceColor, -58, -47) // 右＿親指から8番目
  webTops(ctx, laceColor, -70, -63) // 右＿親指から8番目
  webTops(ctx, laceColor, -85, -80) // 右＿親指から8番目
  webTops(ctx, laceColor, -100, -95) // 右＿親指から8番目

  connectWebToIndexTop(ctx, laceColor, 0, 0)
  connectWebToThumbTop(ctx, laceColor, 3, 3)
  webKnots(ctx, laceColor, 5, -40) // 捕球面寄りのウェブ結び目
  webKnots(ctx, laceColor, -50, 50) // 捕球面寄りのウェブ結び目
}

const designOfWT10WebLeft = (ctx: CanvasRenderingContext2D, x: number, y: number) => {
  ctx.fillStyle = '#EBEBEB'
  ctx.beginPath()
  ctx.moveTo(565 + x, 105 + y) // 左上
  ctx.quadraticCurveTo(557 + x, 100 + y, 560 + x, 112 + y) // 左下
  ctx.quadraticCurveTo(574 + x, 128 + y, 574 + x, 130 + y) // 右下
  ctx.quadraticCurveTo(582 + x, 129 + y, 580 + x, 124 + y) // 右上
  ctx.quadraticCurveTo(565 + x, 105 + y, 565 + x, 105 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const designOfWT10WebRight = (ctx: CanvasRenderingContext2D, x: number, y: number) => {
  ctx.fillStyle = '#EBEBEB'
  ctx.beginPath()
  ctx.moveTo(669 + x, 237 + y) // 左上
  ctx.quadraticCurveTo(665 + x, 242 + y, 668 + x, 247 + y) // 左下
  ctx.quadraticCurveTo(685 + x, 260 + y, 682 + x, 258 + y) // 右下
  ctx.quadraticCurveTo(688 + x, 257 + y, 684 + x, 250 + y) // 右上
  ctx.quadraticCurveTo(669 + x, 237 + y, 669 + x, 237 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
